import { render, staticRenderFns } from "./Detailticket.vue?vue&type=template&id=50085a77"
import script from "./Detailticket.vue?vue&type=script&lang=js"
export * from "./Detailticket.vue?vue&type=script&lang=js"
import style0 from "./Detailticket.vue?vue&type=style&index=0&id=50085a77&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports